import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Counterparty() {
  const [inn, setInn] = useState('');
  const [result, setResult] = useState(null);

  const check = async (e) => {
    e.preventDefault();
    const res = await fetch(API + '/tax/check_counterparty?inn=' + inn);
    setResult(await res.json());
  };

  return (
    <div>
      <h2>Проверка контрагента</h2>
      <form onSubmit={check} style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <input value={inn} onChange={e => setInn(e.target.value)} placeholder="ИНН (10 цифр)" style={{ flex: 1, padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <button type="submit" style={{ padding: '10px 20px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Проверить</button>
      </form>
      {result && (
        <div style={{ marginTop: 16, padding: 16, background: '#1E293B', borderRadius: 8 }}>
          <p>ИНН: {result.inn}</p>
          <p>Статус: {result.status}</p>
          {(result.risks || []).map((r, i) => <p key={i} style={{ color: '#F59E0B' }}>[{r.severity}] {r.description}</p>)}
        </div>
      )}
    </div>
  );
}

export default Counterparty;